import { render } from "./GeralLora.vue?vue&type=template&id=e1d9e81c&scoped=true"
import script from "./GeralLora.vue?vue&type=script&lang=js"
export * from "./GeralLora.vue?vue&type=script&lang=js"

import "./GeralLora.vue?vue&type=style&index=0&id=e1d9e81c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1d9e81c"]])

export default __exports__